var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { Overlay } from "./overlay";
var ThumbnailWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 50px;\n  width: 50px;\n  position: relative;\n"], ["\n  height: 50px;\n  width: 50px;\n  position: relative;\n"])));
var ThumbnailImage = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n"], ["\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n"])));
export var Thumbnail = function (_a) {
    var id = _a.id, src = _a.src, isActive = _a.isActive, onClick = _a.onClick;
    return (React.createElement(ThumbnailWrapper, null,
        React.createElement(ThumbnailImage, { "data-key": id, src: src, onClick: onClick }),
        React.createElement(Overlay, { isActive: isActive })));
};
var templateObject_1, templateObject_2;
